import React from 'react';
import { cn } from './_cn';

const tones = {
  slate: 'bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-300',
  blue: 'bg-blue-50 text-blue-600 dark:bg-sky-900/40 dark:text-sky-300',
  emerald:
    'bg-emerald-50 text-emerald-600 dark:bg-emerald-900/40 dark:text-emerald-300',
  rose: 'bg-rose-50 text-rose-600 dark:bg-rose-900/40 dark:text-rose-300',
  amber: 'bg-amber-50 text-amber-600 dark:bg-amber-900/40 dark:text-amber-300',
  violet:
    'bg-violet-50 text-violet-600 dark:bg-violet-900/40 dark:text-violet-300',
};

const sizes = {
  sm: 'h-8 w-8 rounded-md',
  md: 'h-10 w-10 rounded-md',
  lg: 'h-12 w-12 rounded-md',
};

const iconSizes = {
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-6 w-6',
};

const IconBadge = ({
  icon: Icon,
  tone = 'slate',
  size = 'md',
  className = '',
}) => (
  <span
    className={cn(
      'inline-flex shrink-0 items-center justify-center',
      sizes[size] || sizes.md,
      tones[tone] || tones.slate,
      className,
    )}
  >
    {Icon ? (
      <Icon className={iconSizes[size] || iconSizes.md} aria-hidden />
    ) : null}
  </span>
);

export default IconBadge;
